<div class="alert alert-dismissible fade show" role="alert" *ngFor="let message of messages" [hidden]="!message.show"
[ngClass]="{'alert-success': message.type == 0, 'alert-danger': message.type == 1, 'alert-warning': message.type == 2}">
    <div [innerHTML]="message.value"></div>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="alert" aria-label="Close"></button>
</div>